/**
 * Subscriptions Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const subscriptionsAPI = {
  getAll: (params) => apiClient.get('/subscriptions', { params }),
  getById: (id) => apiClient.get(`/subscriptions/${id}`),
  getStats: (params) => apiClient.get('/subscriptions/stats/summary', { params }),
  getUpcoming: (params) => apiClient.get('/subscriptions/upcoming/next30days', { params }),
  create: (data) => apiClient.post('/subscriptions', data),
  update: (id, data) => apiClient.put(`/subscriptions/${id}`, data),
  delete: (id) => apiClient.delete(`/subscriptions/${id}`),
};

export default subscriptionsAPI;

